import { getAuthHeader } from "~/utils/headers";

import environment from "environment";
// @TODO migration node js api
const basePlaylistCustom = environment.baseApiTracks;

export const getRecentPlaylists = (axios, limit) => axios.get(`${basePlaylistCustom}/playlist/lists/recent?limit=${limit}`);

export const postPlaylistDetailsEdit = (axios, payload) =>
  axios.post(`${basePlaylistCustom}/playlist/edit/details`, payload, getAuthHeader());

export const postPlaylistTrackDelete = (axios, payload) =>
  axios.post(`${basePlaylistCustom}/playlist/track/delete`, payload, getAuthHeader());
export const postPlaylistDelete = (axios, payload) => axios.post(`${basePlaylistCustom}/playlist/list/delete`, payload, getAuthHeader());
export const postPlaylistSort = (axios, payload) => axios.post(`${basePlaylistCustom}/playlist/sort`, payload, getAuthHeader());

export const getPlaylist = (axios, playlistId) => axios.get(`${basePlaylistCustom}/playlist/${playlistId}`);

export const getUserPlaylists = (axios, dir, limit) => axios.get(`${basePlaylistCustom}/playlist/lists/${dir}?limit=${limit}`);

export const getRelatedPlaylist = (axios, trackId) =>
  axios.post(`${basePlaylistCustom}/playlist/related/track`, { trackId }, getAuthHeader());

// comma separated tracks
export const getPlaylistsForTracks = (axios, trackIds) => axios.post(`${basePlaylistCustom}/playlist/list/tracks`, { trackIds });

export const postNewPlaylist = (axios, payload) => axios.post(`${basePlaylistCustom}/playlist/list/add`, payload, getAuthHeader());

export const postTrackToPlaylist = (axios, payload) => axios.post(`${basePlaylistCustom}/playlist/track/add`, payload, getAuthHeader());

export const getCurrentUserPlaylists = (axios, limit = 50) =>
  axios.post(`${basePlaylistCustom}/playlist/user/list?limit=${limit}`, {}, getAuthHeader());

export const getFavoritePlaylists = (axios, limit = 50) =>
  axios.post(`${basePlaylistCustom}/playlist/user/favorites?limit=${limit}`, {}, getAuthHeader());

export const getPlaylistActivity = (axios, limit = 15) =>
  axios.post(`${basePlaylistCustom}/playlist/user/activity?limit=${limit}`, {}, getAuthHeader());

export const getPlaylistFavorite = (axios, playlistId) =>
  axios.get(`${basePlaylistCustom}/favorite?entityId=${playlistId}&entity=playlist`, getAuthHeader());

export const setPlaylistFavorite = (axios, playlistId) =>
  axios.post(`${basePlaylistCustom}/favorite`, { entityId: playlistId, entity: "playlist" }, getAuthHeader());
